A source from which the candidate was obtained from.
